<template lang="pug">
  .login-histories-wrapper
    .login-history-header
      span {{ name }}
      button.close(@click="closeModal") ×
    .login-histories(v-if="isDataPresent")
      table.histories-table(v-if="!loading")
        thead
          th {{ $t('login_history.device') }}
          th {{ $t('login_history.platform') }}
          th {{ $t('login_history.ip') }}
          th {{ $t('login_history.login_at') }}
        tbody
          tr(v-for="history in loginHistories")
            td {{ history.device }}
            td {{ history.platform }}
            td {{ history.ip }}
            td {{ history.login_at }}
    .no-data(v-else)
      h4 {{ $t('login_history.no_data') }}
      
</template>

<script>
  import { api } from '@/api.js'

  export default {
    props: {
      id: {
        type: Number,
        default() {
          return null
        }
      },
      name: {
        type: String,
        default() {
          return ''
        }
      }
    },

    data() {
      return {
        loading: false,
        loginHistories: []
      }
    },

    computed: {
      loadHistoriesUrl() {
        return `/users/${this.id}/login_history`
      },

      isDataPresent() {
        return this.loginHistories.length > 0
      }
    },

    created() {
      this.loading = true
      if (this.id != null) {
        this.loadHistories()
      }
    },

    methods: {
      loadHistories() {
        api.get(this.loadHistoriesUrl).then((resp) => {
          this.loginHistories = resp.data.data
          this.loading = false
        })
      },

      closeModal() {
        this.$emit('closeModal')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-history-header {
    display: flex;
    justify-content: space-between;

    span {
      color: #3d4a57;
      font-size: 17px;
      font-weight: 700;
    }

    button:focus {
      outline: none;
    }
  }

  .login-histories {
    height: 70vh;
    overflow: scroll;
  }

  .histories-table {
    width: 100%;

    thead {
      th {
        color: #7c91a7;
        font-size: 12px;
        padding: 20px 0;
        white-space: nowrap;
        width: 25%;
      }
    }

    tbody {
      tr {
        td {
          border-bottom: 1px solid #e7ecf4;
          border-top: 1px solid #e7ecf4;
          color: #313541;
          font-size: 14px;
          height: 60px;
          width: 25%;
        }
      }
    }
  }

  .no-data {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    margin-top: 40px;
  }
</style>
